interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/**
 * Outlined star for the "Favourites" category tab.
 *
 * A separate icon rather than reusing `Star.tsx`: that one is filled, which
 * clashes with the outlined grid/folder glyphs on the tabs either side of it,
 * and it renders through Chakra's `Icon` — so its `width`/`height` are read as
 * Chakra spacing tokens (`width={13}` meant 3.25rem, not 13px) and it came out
 * roughly four times the intended size. Plain SVG attributes here take real
 * pixels, matching AllBlocksTabIcon and OthersTabIcon.
 */
const FavouritesTabIcon = ({ width = 14, height = 14, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7 1.4L8.73 4.905L12.6 5.47L9.8 8.198L10.461 12.05L7 10.23L3.539 12.05L4.2 8.198L1.4 5.47L5.27 4.905L7 1.4Z'
        stroke={color}
        strokeWidth='1.1'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default FavouritesTabIcon;
